"use client";

import { Outlet, useParams } from "react-router-dom";
import { type SupportedLanguage } from "@/lib/shared";
import { resolveLocale } from "@/lib/resolvedLocale";
import ApplyJobLeftPanel from "@/components/apply-job/ApplyJobLeftPanel";
import ApplyJobMobileHero from "@/components/apply-job/ApplyJobMobileHero";
import ApplyJobFlowPrefetch from "@/components/apply-job/ApplyJobFlowPrefetch";
import ApplyJobJobContextSync from "@/components/apply-job/ApplyJobJobContextSync";

/**
 * غلاف مسارات التقديم — يطابق `hr-web-main` `app/[locale]/apply-job/layout.tsx`:
 * عمود يسار (صورة + نص) + عمود أيمن للمحتوى (النماذج).
 */
export default function ApplyJobRouteLayout() {
  const params = useParams();
  const locale = resolveLocale(params.locale as string | undefined);

  return (
    <div className="relative flex min-h-screen w-full flex-col bg-gray-100 md:flex-row">
      <ApplyJobJobContextSync />
      <ApplyJobFlowPrefetch locale={locale} />
      <ApplyJobMobileHero locale={locale} />
      <ApplyJobLeftPanel locale={locale} />
      {/* مطابق لـ hr-web-main layout: عمود النماذج نصف العرض، ml-auto / RTL مرآة */}
      <div className="relative z-10 flex w-full flex-1 flex-col bg-white min-h-0 md:ml-auto md:h-screen md:min-h-0 md:w-1/2 md:overflow-y-auto md:overscroll-y-contain rtl:md:ml-0 rtl:md:mr-auto">
        <Outlet />
      </div>
    </div>
  );
}
